import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  InitialAvatarIcon,
  Heading,
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';

interface Props {
  isOpen: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TotalWithdrawModal',
  props: {
    isOpen: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,Modal, InitialAvatarIcon, Heading, BaseText, ButtonContainer, ButtonPrimary, ButtonSecondary, Portal }
}

})